import get from 'lodash/get'
import OLControlAttribution from 'ol/control/Attribution'
import OLControlScaleLine from 'ol/control/ScaleLine'

import { getMap } from 'utils/MapUtils'

// Work around html2canvas not being able to capture WebGL layers, giving the
// following error: Unable to clone WebGL context as it has preserveDrawingBuffer=false
// Solution from: https://stackoverflow.com/a/55762772
HTMLCanvasElement.prototype.getContext = (function (origFn) {
  return function (type, attribs) {
    attribs = attribs || {}
    attribs.preserveDrawingBuffer = true
    return origFn.call(this, type, attribs)
  }
}(HTMLCanvasElement.prototype.getContext))

export const html2canvasWrapper = async (htmlElement, options) => {
  const html2canvas = (await import('html2canvas')).default
  return html2canvas(htmlElement, options)
}

export const getMapAsCanvas = async () => {
  console.debug('CanvasTools - getMapAsCanvas')

  const map = getMap()

  const mapElement = map.getViewport()

  // Hide all controls except for ScaleLine and Attribution
  const controlsArray = map.getControls().getArray() || []
  const hiddenControls = []
  for (const control of controlsArray) {
    const keepControl = control instanceof OLControlScaleLine || control instanceof OLControlAttribution
    if (!keepControl) {
      const style = get(control, 'element.style')
      if (style) {
        // Keep track of current display property so we can restore it later
        hiddenControls.push([control, style.display])

        // Hide control. It would be nice if it had a convenience method instead
        style.display = 'none'
      }
    }
  }

  let mapCanvas = null

  // Generate map canvas including scale bar using html2canvas
  try {
    mapCanvas = await html2canvasWrapper(mapElement)
  } catch (error) {
    console.log('CanvasTools - error getting map canvas', error)
  }

  // Restore hidden controls
  console.debug('CanvasTools - getMapAsCanvas - restoring hiddenControls', hiddenControls)

  for (const [control, display] of hiddenControls) {
    control.element.style.display = display
  }

  return mapCanvas
}
